import $ from 'jquery';
import useSetEnv from '@global/composable/useSetEnv';

/**
 * @description 手機板收合、桌機板收合
 */
const { setEnv } = useSetEnv();
const isMobile = setEnv.myEquipment();

function toggleMenu(selector) {
  if (!selector) {
    console.warn('toggleMenu: selector is required.');
    return;
  }

  $(selector).on('click', function () {
    $(this).toggleClass('open').next('ul').slideToggle();
  });
}

function corpPage() {
  if (isMobile) {
    toggleMenu('.corp-menu > h2');
  }
}

function memberPage() {
  if (isMobile) {
    toggleMenu('.member-menu > h3');
  }
}

function useCorpPage() {
  return { corpPage, memberPage };
}

export default useCorpPage;
